import React from 'react';
import './Timeline.css';
import oneVideo from '../images/ic_type_video.png';
import multiPhotos from '../images/ic_multi_photos.png';
import icChallenge from '../images/icon_voted_challenge.png';
import icStarCircle from '../images/ico_star_circle.png';
import icStar from '../images/ico_star.png';
import Spinner from '../Spinner';
import { cdnMaker } from '../helper/CDNHelper';

class Timeline extends React.Component {

  componentDidMount(){
    window.addEventListener('scroll', this.onScroll, false);
  }

  componentWillUnmount(){
    window.removeEventListener('scroll', this.onScroll, false);
  }

  onScroll = () => {
    if(
      (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 500) &&
      this.props.timeline.length &&
      !this.props.isLoading &&
      !this.props.isError &&
      this.props.hasMore
    ){
      this.props.onPaginatedSearch();
    }
  }

  render(){
    const {user, timeline, isLoading, page, isError, onPaginatedSearch, hasMore} = this.props;
    
    if (null === timeline) {
      return <div></div>
    }

    const battleCell = timeline.map((item, index) =>

      index === 0 && item.isCompound ?
        <div key={item.id} className="battlecell" >
          <a href={`/${user.username}/starred`}>
            <div className="starContainer">
              <img className="gifImageStar" src={cdnMaker(item.post.thumbnailUrl)} alt=""></img>
              <img className="gifImageStar" src={item.second} alt=""></img>
              <img className="gifImageStar" src={item.third} alt=""></img>
              <img className="gifImageStar" src={item.fourth} alt=""></img>
            </div>
            <img className='starImage' src={icStarCircle} alt=''></img>
          </a>
        </div>
      :
        <div key={item.id} className="battlecell" >
          <a href={`/p/${item.post.shareId}`}>
            <img className="gifImage" src={item.post.type === 'ov' ? cdnMaker(item.post.thumbnailUrl) : cdnMaker(JSON.parse(item.post.contentUrls)[0])} alt=""></img>

            {
              item.priority > 0 && <img id='star' src={icStar} alt=''/>
            }

          </a>

          {
            item.post.type === 'ov' &&
            <img id='typeVideo' src={oneVideo} alt=''></img>
          }

          {
            item.post.type === 'mp' &&
            <img id='typePhoto' src={multiPhotos} alt=''></img>
          }
        </div>
    )

    //
    // {
    //   (item.battle.type === 'challenge' && item.battle.user1VotesCount > 0) &&
    //   <div id='challengeContainer'>
    //     <img id='challengeIcon' src={icChallenge} alt=''></img>
    //     <span id='chanllengeVote'>{item.battle.user1VotesCount}</span>
    //   </div>
    // }

    return (
      <div>
        <div className='grid'>
          {battleCell}
        </div>

        <div className='interactions'>
          {isLoading && <Spinner/>}
        </div>

        <div className='interactions'>
          {
            (page !== null && !isLoading && isError && hasMore) &&
            <div>
              <div>
                something went wrong...
              </div>
              <button
                type='button'
                onClick={onPaginatedSearch}
                >
                  Try Again
                </button>
            </div>
          }
        </div>

      </div>

    );
  }

}

export default Timeline;
